import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import * as _ from "lodash";
import * as React from "react";
import { connect } from "react-redux";

import { StoreState } from "../store";
import { AreaType, MarketShareState } from "../types/index";
import ProgressOverlay from "./ProgressOverlay";

function mapStateToProps({ marketShare, marketShareFilter }: StoreState) {
  return {
    marketShare,
    marketShareFilter,
  };
}

type Props = ReturnType<typeof mapStateToProps>;

class MarketShareOverview extends React.Component<
  Props & StyledComponentProps
> {
  public getAverageMarketShare(
    marketShare: MarketShareState
  ): [number | undefined, number] {
    const marketShareArray = [];
    let suppliedHouseholds = 0;
    let totalHouseholds = 0;
    for (const feature of marketShare.postcodes.features) {
      if (this.checkIfPostalcodeInSelection(feature.properties.postcode)) {
        if (feature.properties.marketShare.totalHouseholds !== undefined) {
          suppliedHouseholds +=
            feature.properties.marketShare.suppliedHouseholds;
          totalHouseholds += feature.properties.marketShare.totalHouseholds;
        }
      }
    }
    return [
      totalHouseholds > 0 ? suppliedHouseholds / totalHouseholds : undefined,
      marketShareArray.length,
    ];
  }

  public checkIfPostalcodeInSelection = (postcode: string): boolean => {
    const postCodeNotIAButIAFilter =
      this.props.marketShare.postcodesIA.indexOf(postcode) === -1 &&
      _.isEqual(this.props.marketShareFilter.areaType, [AreaType.IA]);
    const postCodeNotOOAButOOAFilter =
      this.props.marketShare.postcodesIA.indexOf(postcode) !== -1 &&
      _.isEqual(this.props.marketShareFilter.areaType, [AreaType.OOA]);
    const isManuallySelected = this.props.marketShareFilter.selectedPostalCodes
      .length
      ? this.props.marketShareFilter.selectedPostalCodes
          .map((e) => e.value)
          .indexOf(postcode) >= 0
      : true;

    return (
      !(postCodeNotIAButIAFilter || postCodeNotOOAButOOAFilter) &&
      isManuallySelected
    );
  };

  public render() {
    const { classes } = this.props;
    const averageMarketShare = this.getAverageMarketShare(
      this.props.marketShare
    );

    const getMarketShareLabel = () =>
      averageMarketShare[0] !== undefined && averageMarketShare[1] > 1
        ? "Marktanteil (gemittelt):"
        : "Marktanteil:";

    const getMarketShareValueString = () =>
      averageMarketShare[0] === undefined
        ? "kann für das gewählte Gebiet nicht berechnet werden"
        : averageMarketShare[0] < 0.05
        ? "ca. " + _.ceil(averageMarketShare[0] * 1000) / 10 + "%"
        : "ca. " + Math.min(_.ceil(averageMarketShare[0] * 100), 85) + "%";

    return (
      <Paper className={classes && classes.paper}>
        <ProgressOverlay loading={this.props.marketShare.loading}>
          <Typography variant="h6">Marktanteil</Typography>
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={6}>
              <Table className={classes && classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell align="right" />
                    <TableCell align="left" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes && classes.tableCellNames}>
                      {getMarketShareLabel()}
                    </TableCell>
                    <TableCell className={classes && classes.tableCellValues}>
                      {getMarketShareValueString()}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </ProgressOverlay>
      </Paper>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
  },
  saveButton: {
    margin: theme.spacing(1),
    marginRight: theme.spacing(4),
  },
  table: {
    fontWeight: 400,
    width: "auto",
  },
  tableCellNames: {
    fontSize: "1rem",
    "padding-right": "0px",
    width: "180px",
  },
  tableCellValues: {
    fontSize: "1rem",
    "padding-left": "0px",
  },
});

export default connect(mapStateToProps)(
  withStyles(styles)(MarketShareOverview)
);



// WEBPACK FOOTER //
// ./src/components/MarketShareOverview.tsx